var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#98B2BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7112 23.4144C14.5424 23.7945 13.295 24 12 24C10.704 24 9.45585 23.7943 8.28636 23.4136C8.82659 23.4784 9.02622 23.1266 9.02622 22.8229C9.02622 22.6907 9.02396 22.4575 9.02094 22.1456C9.01745 21.7846 9.01294 21.3182 9.00972 20.7808C5.67147 21.5065 4.96722 19.1709 4.96722 19.1709C4.42197 17.784 3.63522 17.4147 3.63522 17.4147C2.54547 16.6694 3.71772 16.6846 3.71772 16.6846C4.92147 16.7694 5.55522 17.9221 5.55522 17.9221C6.62622 19.7572 8.36397 19.2274 9.04797 18.9196C9.15672 18.1436 9.46722 17.6143 9.80997 17.3142C7.14522 17.0111 4.34397 15.9813 4.34397 11.3799C4.34397 10.0687 4.81122 8.99704 5.57922 8.15715C5.45547 7.85327 5.04372 6.63288 5.69622 4.97947C5.69622 4.97947 6.70422 4.65671 8.99622 6.21032C9.95397 5.94382 10.98 5.81113 12.0007 5.80571C13.02 5.81094 14.0467 5.94382 15.0052 6.21032C17.2957 4.65671 18.3015 4.97947 18.3015 4.97947C18.9562 6.63288 18.5445 7.85327 18.4207 8.15715C19.1902 8.99704 19.6545 10.0687 19.6545 11.3799C19.6545 15.9925 16.8487 17.0081 14.1757 17.3052C14.6062 17.676 14.9902 18.4084 14.9902 19.529C14.9902 20.6025 14.9835 21.537 14.9791 22.1563C14.9769 22.4631 14.9752 22.6925 14.9752 22.8231C14.9752 23.1282 15.17 23.4807 15.7112 23.4144Z",
    fill: "#F7F9FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.b02f639a3bcaa4242e6795fb18643708.svg";
export { ForwardRef as ReactComponent };